import { Injectable } from '@angular/core';
const GENERIC_MOCK_FLAG = 'mockBackEnd';
const PASS_TO_BACKEND_ENDPOINTS_FLAG = 'passToBackendEndPoints';
const INIT_MOCKED_DATA_FLAG = 'initMockedData';

@Injectable()
export class ServiceConfiguration {

  public static isMockBackEnd(): boolean {
    if (!localStorage[GENERIC_MOCK_FLAG]) {
      localStorage.setItem(GENERIC_MOCK_FLAG, 'false');
    }
    return localStorage[GENERIC_MOCK_FLAG] === 'true';
  }

  /*usage: turn off mocking of specific urls which already has a handler
  example: ['specificUrlA', 'specificUrlB']
  both urls will passThru to the backend
  */
  public static shouldMockSpecificURL(url: string): boolean {
    if (!localStorage[PASS_TO_BACKEND_ENDPOINTS_FLAG]) {
      localStorage.setItem(PASS_TO_BACKEND_ENDPOINTS_FLAG, '[]');
    }
    return !(localStorage[PASS_TO_BACKEND_ENDPOINTS_FLAG] as Array<string>).includes(url) && ServiceConfiguration.isMockBackEnd();
  }

  public static getBaseURL(url: string) {
    return url.split('/').pop();
  }

  public static shouldInitMockData(url: string) {
    if (!localStorage[INIT_MOCKED_DATA_FLAG]) {
      localStorage.setItem(INIT_MOCKED_DATA_FLAG, '[]');
    }
    return (localStorage[INIT_MOCKED_DATA_FLAG] as Array<string>).includes(url);
  }
}


